module.exports = __webpack_public_path__ + "img/vpn-2.faa2127a.jpg";